import React from 'react';
import {
  TableFilters,
  TableFilterSelect,
  InputContainer,
  SearchableSelect,
} from '../../design-system';
import { clientYardService } from '../../services';
import { useStore } from '../../context';
import { extendContainerValidator, showToRoles } from '../../utils';
import {
  INPUT_ERRORS,
  inventoryItemStatusOptions,
  inventoryItemStatusSecondaryOptions,
} from '../../const';
import { i18n } from '../../i18n';
import { useSaveFilters } from '../../hooks';

interface Props {
  clientId?: string;
  yardId: string;
  number?: string;
  status?: string;
  setStates: any;
  clientData?: any;
}

export const Filters: React.FC<Props> = ({
  clientId = '',
  yardId,
  number = '',
  status = 'All',
  setStates,
  clientData,
}: Props) => {
  const {
    state: {
      user: { data: user },
    },
  } = useStore();
  const [oldFilters, setOldFilters] = useSaveFilters('belongs-to', true);

  return (
    <TableFilters>
      {!clientData && (
        <>
          {showToRoles(
            ['SUPER_ADMIN', 'YARD_COMPANY_ADMIN', 'YARD_COMPANY_VIEWER', 'YARD_MANAGER'],
            user,
          ) && (
            <SearchableSelect
              selectedOptionLabel={oldFilters.clientName}
              label={i18n.t('label.client')}
              onSelect={(obj: any) => {
                if (obj && obj.id) {
                  setOldFilters({ ...oldFilters, clientName: obj.label });
                  setStates('force', { clientId: obj.id });
                } else {
                  setOldFilters({ ...oldFilters, clientName: '' });
                  setStates('force', { clientId: '' });
                }
              }}
              queryFn={() => {
                return clientYardService.assignedClients({
                  id: yardId,
                });
              }}
              queryKey={['clients', 'assigned-clients' + yardId]}
              selectedAreasEqaul={{ key: 'id', keys: [clientId] }}
              withClearButton
            />
          )}
          <InputContainer
            label={i18n.t('label.containerNumber')}
            data-size={'medium'}
            defaultValue={number}
            onChange={(e) => setStates('number', e.target.value)}
            helperText={
              number.length !== 0 && number.length < 3
                ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER_MIN
                : !extendContainerValidator(number)
                ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER_SHORT
                : ''
            }
            alwaysShowHelperText
          />
        </>
      )}
      <TableFilterSelect
        label={i18n.t('label.status')}
        options={clientData ? inventoryItemStatusSecondaryOptions : inventoryItemStatusOptions}
        value={status}
        onChange={(e) => setStates('force', { status: e.target.value })}
      />
    </TableFilters>
  );
};
